import React from 'react';
import { Link } from 'react-router-dom';
import monoCartonImg from '../images/products/mono-cartons.jpg';
import rigidBoxImg from '../images/products/rigid-boxes.jpeg';
import labelImg from '../images/products/printed-labels.jpg';
import windowBoxImg from '../images/products/window-patch.jpg';
import specialtyImg from '../images/products/specialty-finishes.jpg';
import sleeveImg from '../images/products/sleeve-packaging.jpg';
import displayBoxImg from '../images/products/display-boxes.jpg';

const Portfolio = () => {
    return (
        <>
            <div className="my-4 py-4" id='portfolio'>
                <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">Products</h2>
                <div className='flex justify-center'>
                    <div className='w-24 border-b-4 border-blue-900 mb-8'></div>
                </div>

                <div className="px-4" data-aos="fade-down" data-aos-delay="600">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                        {[{
                            title: "Mono Cartons",
                            description: "Sleek, customizable paperboard cartons ideal for cosmetics, healthcare, and personal care items. Choose from various shapes, finishes, and lock styles.",
                            img: monoCartonImg
                        }, {
                            title: "Rigid Boxes",
                            description: "High-end, durable packaging with luxurious finishes. Perfect for perfumes, gift sets, and premium product lines.",
                            img: rigidBoxImg
                        }, {
                            title: "Printed Labels",
                            description: "Custom labels in roll or sheet form with foil, matte, gloss, or transparent finishes — tailored for bottles, jars, and boxes.",
                            img: labelImg
                        }, {
                            title: "Window Patch Boxes",
                            description: "Clear-window boxes for showcasing your product while keeping it secure. Ideal for soaps, stationery, and kits.",
                            img: windowBoxImg
                        }, {
                            title: "Specialty Finishes",
                            description: "Enhance packaging appeal with foil stamping, spot UV, embossing, debossing, and soft-touch lamination. Adds elegance and retail impact.",
                            img: specialtyImg
                        }, {
                            title: "Sleeve Packaging",
                            description: "Custom paperboard sleeves for boxes or trays — ideal for minimalist branding, combo offers, and cost-effective elegance.",
                            img: sleeveImg
                        }, {
                            title: "Display Boxes",
                            description: "Retail-ready boxes with built-in display stand design. Boost shelf appeal for compact products like soaps, lip balms, and samples.",
                            img: displayBoxImg
                        }].map((product, idx) => (
                            <div key={idx} className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 min-h-max">
                                <div className="m-2 text-justify text-sm">
                                    <img
                                        src={product.img}
                                        alt={product.title}
                                        className="w-full h-40 object-cover rounded-lg mb-4"
                                    />
                                    <h4 className="font-semibold text-lg md:text-2xl text-center mb-4 h-12">{product.title}</h4>
                                    <p className="text-md font-medium leading-5 h-auto md:h-48">
                                        {product.description}
                                    </p>
                                    <div className="flex justify-center my-4">
                                        <Link to="/get-demo" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                                            Request Sample
                                            <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                                            </svg>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Portfolio;